import type { FaireProductEntity } from "../../entity_types/product";

export const p_ne4aqt5ujh: FaireProductEntity = {
  token: "p_ne4aqt5ujh",
  type: "product",
  name: "Radiant Country 1000 Piece Jigsaw Puzzle",
  brandToken: "b_2rys9jdptm",
  brandName: "Toynk",
  imageUrl: "https://cdn.faire.com/fastly/e106095763c6055823953ba51857140458b7e2eb7f37f936721ba1685f35a19f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e0f837dd9fb151503784de66579e6fd93f5e5c0452e4b768bd9ccb71dad4478.jpeg",
    "https://cdn.faire.com/fastly/9a87cd41b025f53d05e8fafe8192c1ad7dbdd0d367335c1a7e0f555833550c6a.jpeg"
  ],
  priceDollars: 13.86,
  description: "MasterPieces is an USA Arizona based Puzzle & Game Company. For over 25 years we’ve specialized in creating jigsaw puzzles for both children and adults. From new puzzlers to the avid puzzle enthusiasts, we design our puzzles using thick durable puzzle board to offer a higher quality puzzling experience. Our puzzles are environmentally friendly and designed with non-toxic soy-based inks. Jigsaw Puzzles make the perfect gift for anyone who enjoys a relaxing evening activity or a mind-bending challenge! The MasterPieces Kids collection offers a wide variety of puzzles with vibrant colors and unique themes and styles. The Right Fit Guide was developed with your little one in mind and is designed to help match the piece count and piece size to the age and skill level of the child. Enjoy piecing together wildlife, silly characters and images with hidden shapes and patterns to help little ones develop their cognitive skills and have fun! Our high-quality packaging will let you save, store, and enjoy puzzling time and time again. When you choose MasterPieces, quality isn’t just a promise..",
  tags: [],
  msrpDollars: 24.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:14.150Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
